import * as allFeedActions from '../../action_creators/homepage/all_feed_action_creators';
import AllFeedModel from '../../../models/homepage/all_feed_module';
import log from '../../../services/logger_service';

export default function fetchAllFeedIS(dispatch) {
  return function fetchModelData(params, config) {
    dispatch(allFeedActions.allFeedISLoading());
    return AllFeedModel.fetchAllFeedIS(params, config)
      .then(function handleAuthorAllFeedData(AllFeedData) {
        dispatch(allFeedActions.allFeedISLoaded(AllFeedData.data, config));
      })
      .catch(function handleAuthorAllFeedError(err) {
        dispatch(allFeedActions.allFeedISError(err, config));
        log.error(
          err,
          `Error in all  all feed actions, message: ${err.message}`
        );
      });
  };
}
